import { Component, MouseEvent } from 'react';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import { BackgroundType, RootState } from 'types';
import { checkDifferent, getMode } from 'utils/formHandlers';
import { twclsx } from 'utils/twclsx';

interface ChangeLayerProps {
    backgrounds: BackgroundType[];
    save: boolean;
    changeBackground: (background: BackgroundType, mode: string, save: boolean) => void;
    changeOverlay: (overlay: BackgroundType, mode: string, save: boolean) => void;
    openMenu?: boolean;
    openTool?: boolean;
    mode: string;
    move: boolean;
}

interface ChangeLayerState {
    backgrounds: BackgroundType[];
    showMore: string;
    showMoreOpacity: string;
    openMenu?: boolean;
    openTool?: boolean;
}

class ChangeLayer extends Component<ChangeLayerProps, ChangeLayerState> {
    constructor(props: ChangeLayerProps) {
        super(props);
        this.state = {
            backgrounds: [],
            showMore: 'hidden',
            showMoreOpacity: 'fadeOut',
            openMenu: props.openMenu,
            openTool: props.openTool,
        };
    }

    static getDerivedStateFromProps(props: ChangeLayerProps, state: ChangeLayerState) {
        if (checkDifferent(props.backgrounds, state.backgrounds)) {
            return { backgrounds: props.backgrounds };
        }
        if (props.openMenu !== state.openMenu || props.openTool !== state.openTool) {
            return { openMenu: props.openMenu, openTool: props.openTool };
        }

        return null;
    }

    handleMouseOver = () => {
        if (this.state.showMore === 'hidden') {
            this.setState({ showMore: 'block', showMoreOpacity: 'fadeIn' });
        }
    };

    handleMouseLeave = () => {
        if (this.state.showMore === 'block') {
            this.setState({ showMoreOpacity: 'fadeOut' }, () => {
                setTimeout(() => this.setState({ showMore: 'hidden' }), 200);
            });
        }
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.openMenu && this.props.move ? 'ml-changeLayer' : 'ml-14',
                    'z-10',
                    'margin-transition',
                    'rounded-md',
                    'flex',
                    'flex-row-reverse',
                    'select-none',
                    'justify-end',
                    'absolute',
                    'top-0',
                    'left-0',
                    'p-1',
                    'mr-2',
                    'mt-4',
                    'h-20',
                    'w-auto'
                )}
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver={this.handleMouseOver}
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseLeave={this.handleMouseLeave}
            >
                <div
                    className={twclsx(
                        'bg-white',
                        'rounded-md',
                        'p-1',
                        'h-16',
                        'ml-2',
                        'border',
                        'border-gray-500',
                        this.state.showMore,
                        this.state.showMoreOpacity
                    )}
                >
                    <div className="flex ">
                        {this.state.backgrounds
                            .filter((x) => x.type === 'basemap' && x.status === 'inactive')
                            .map((x) => (
                                <div
                                    key={x.id}
                                    className={twclsx(
                                        'border-2',
                                        'relative',
                                        'rounded-sm',
                                        'cursor-pointer',
                                        'w-14',
                                        'h-full'
                                    )}
                                    onClick={(e: MouseEvent<HTMLImageElement>) => {
                                        e.preventDefault();
                                        this.props.changeBackground(x, getMode(this.props.mode), this.props.save);
                                    }}
                                >
                                    <Image alt="" className="rounded-sm" src={`/static/background/${x.image}.png`} />
                                    <div className="absolute rounded-sm capitalize   bottom-0 align-bottom leading-none   text-base  flex flex-col justify-end items-center pb-1  h-full w-full   text-white  text-center bottom-gradient">
                                        {x.name}
                                    </div>
                                </div>
                            ))}

                        {this.state.backgrounds
                            .filter((x) => x.type === 'overlay')
                            .map((x) => (
                                <div
                                    key={x.id}
                                    className={twclsx(
                                        x.status === 'active' ? 'border-primary-active' : 'border-white',
                                        'border-2',
                                        'rounded-sm',
                                        'cursor-pointer',
                                        'w-14',
                                        'h-full',
                                        'relative'
                                    )}
                                    onClick={(e: MouseEvent<HTMLImageElement>) => {
                                        e.preventDefault();
                                        this.props.changeOverlay(x, getMode(this.props.mode), this.props.save);
                                    }}
                                >
                                    <Image alt="" className="rounded-sm" src={`/static/background/${x.image}.png`} />
                                    <div className="absolute rounded-sm capitalize   bottom-0 align-bottom leading-none   text-base  flex flex-col justify-end items-center pb-1  h-full w-full   text-white  text-center bottom-gradient">
                                        {x.name}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
                <div className="  rounded-md flex cursor-pointer     bg-white border border-gray-500   p-1 w-16 h-16">
                    {this.state.backgrounds
                        .filter((x) => x.type === 'basemap' && x.status === 'active')
                        .map((x) => (
                            <div className="relative w-full h-full" key={x.id}>
                                <Image
                                    alt=""
                                    className="rounded-sm absolute left-0 top-0 w-full h-full"
                                    src={`/static/background/${x.image}.png`}
                                />
                                <div className="absolute capitalize rounded-md bottom-0 align-bottom leading-none   text-base  flex flex-col justify-end items-center pb-1  h-full w-full   text-white  text-center bottom-gradient">
                                    {x.name}
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        );
    }
}

const changeLayerStateToProps = (state: RootState) => ({
    openMenu: state.layout.layout.openMenu,
    openTool: state.layout.layout.openTool,
    mode: state.layout.mode,
});

const changeLayerDispatchToProps = () => ({});

export default connect(changeLayerStateToProps, changeLayerDispatchToProps)(ChangeLayer);
